/**
 * AW Collection
 * View mode toggle (3-col / 4-col / 6-col image-only) with localStorage persistence.
 * Filter group collapse is handled by aw-collapse.js.
 */

(function () {
  const STORAGE_KEY = 'aw-coll-view';
  const VIEW_CLASSES = ['aw-coll-grid--large', 'aw-coll-grid--default', 'aw-coll-grid--compact'];

  function initViewToggle() {
    const grid = document.getElementById('main-collection-product-grid');
    const buttons = document.querySelectorAll('.aw-coll-view-btn');
    if (!grid || !buttons.length) return;

    function setView(view) {
      VIEW_CLASSES.forEach((c) => grid.classList.remove(c));
      grid.classList.add('aw-coll-grid--' + view);  // view = 'large' | 'default' | 'compact'

      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.view === view);
      });

      try { localStorage.setItem(STORAGE_KEY, view); } catch (_) {}
    }

    // Restore saved preference (default: default)
    let savedView = 'default';
    try { savedView = localStorage.getItem(STORAGE_KEY) || 'default'; } catch (_) {}
    setView(savedView);

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => setView(btn.dataset.view));
    });
  }

  document.addEventListener('DOMContentLoaded', initViewToggle);
  document.addEventListener('shopify:section:load', initViewToggle);
  document.addEventListener('aw:collection-rendered', initViewToggle);
})();